import React, { useState } from 'react';

/* Icons */
import ChevronUp from '~/../symbols/chevron-up.svg'
import CrossIcon from '~/../symbols/cross.svg'
import InfoIcon from '~/../symbols/info-circle.svg'

/* Common */
import { Button } from '~/components/common';
import { Icon } from '~/components/common';

/* Images */
import placeholder from '~/../img/vehicle-placeholder.jpg';

/* Components */
import ProductSticker from '../../product-sticker/components/ProductSticker';

/* Utilities */
import { trans, getCloudimageUrl } from '~/utilities';

export default function ConversionSummary({ flow, flowGroups, finishedGroups, activeStep, status }) {
    const [showSummary, setShowSummary] = useState(false);

    return (
        <div className={`card card--summary mb-0 mb-lg-4 ${ showSummary ? 'is-open' : '' }`}>
            <div className="card__drawer">
                <button className="btn btn-none btn--close d-lg-none" type="button" onClick={() => setShowSummary(!showSummary)}>
                    <Icon
                        size={14}
                        className={`btn__icon icon icon--chevron`}
                        url={CrossIcon?.url}
                    />
                </button>
                <p className="card__title font-weight-bold mb-5">{trans('app.flow.summary.title')}</p>
                <div className="row gutters-2 gutters-lg-3">
                    {(flow && flow.summary.vehicle && flow.summary.vehicle.brand) && (
                        <div className="col-12">
                            <div className="d-flex justify-content-between">
                                <div className="mr-2">
                                    <p className="font-weight-bold card__brand mb-0">{flow.summary.vehicle.brand}</p>
                                    <p className="text-muted--60 mb-0">{flow.summary.vehicle?.model} {flow.summary.vehicle?.type}</p>
                                    {flow.summary.vehicle.sticker && (
                                        <div className="mt-1">
                                            <ProductSticker
                                                sticker={flow.summary.vehicle.sticker}
                                                stickerTooltips={{
                                                    0: {
                                                        image: flow.summary.vehicle.sticker?.tooltip_image,
                                                        text: flow.summary.vehicle.sticker?.tooltip_text
                                                    }
                                                }}
                                            />
                                        </div>
                                    )}
                                </div>
                                <div>
                                    <img
                                        className="img-fluid img__vehicle"
                                        src={getCloudimageUrl(flow.summary.vehicle.image ? flow.summary.vehicle.image : `${ window.location.origin }${ placeholder }`, { w: 110, h: 82, func: 'crop' })}
                                        srcSet={`${ getCloudimageUrl(flow.summary.vehicle.image ? flow.summary.vehicle.image : `${ window.location.origin }${ placeholder }`, { w: 220, h: 164, func: 'crop' }) } 2x`}
                                        width="110"
                                        height="82"
                                        alt=""
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                    {flow && flow.summary && Object.entries(flow.summary?.categories || {})?.map(([key, category], index) => {
                        if (!category.group || finishedGroups[category.group]?.completed) {
                            return (
                                <div key={key} className="col-12">
                                    <div className="pt-2 pt-lg-3 border-top">
                                        <div className="row gutters-0">
                                            {category?.title && (
                                                <div className="col-12">
                                                    <p className="font-weight-bold">
                                                        {category?.title}
                                                    </p>
                                                </div>
                                            )}

                                            {Object.entries(category?.values || {})?.map(([key, value]) => (
                                                <div key={key} className="d-flex w-100 align-items-start justify-content-between">
                                                    <p className={`mb-0 ${ value?.label === 'Totaal' ? 'font-weight-bold' : 'text-muted--60' }`}>{value?.label}</p>
                                                    <p className="font-weight-bold mb-0">{value?.value}</p>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    })}
                    {flow && (
                        <div className="col-12">
                            <div className="card__info mt-2">
                                <Icon
                                    size={20}
                                    className={`btn__icon icon mr-1 text-muted--40`}
                                    url={InfoIcon?.url}
                                />
                                {(flow.summary.vehicle.voertuigsoort === 'BEDRIJF' || flow.summary.vehicle.voertuigsoort === 'OPLEGGER' || flow.summary.vehicle.voertuigsoort === 'TREKKER') ? (
                                    <p className="text-muted--60">{trans('app.flow.summary.vat_excl_text')}</p>

                                ) : (
                                    <p className="text-muted--60">{trans('app.flow.summary.vat_text')}</p>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <div className="card__sticky d-lg-none">
                <div className="row gutters-0">
                    <div className="col-6">
                        <button
                            className="btn btn-none btn-block d-flex align-items-center justify-content-between"
                            type="button"
                            onClick={() => setShowSummary(!showSummary)}
                        >
                            <span className="btn__text">{trans('app.flow.summary.title')}</span>
                            <Icon
                                size={10}
                                className={`btn__icon icon icon--chevron icon--lg-18`}
                                url={ChevronUp?.url}
                            />
                        </button>
                    </div>
                    <div className="col-6">
                        <Button
                            className="btn-block"
                            theme="success"
                            loading={status !== 'idle'}
                            loadingSize={14}
                            disabled={status !== 'idle'}
                            title={activeStep === (Object.entries(flowGroups || {}).length - 1) ? flow?.form?.buttonLabel : trans('app.flow.next_step_button')}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
